<template>
    <div class="container">
        <ClcmsMenu @productsSelect="productsSelect"/>
        <div>
            <div class="introduction" >
                <div class="introductionTitle">
                    <h1 data-aos="fade-up">Ecell细胞全生命周期信息管理系统</h1>
                    <div data-aos="fade-up"></div>
                    <div data-aos="fade-up">
                      上海唐颐信息技术有限公司为上海干细胞产业联盟发起成员单位、《干细胞转化临床研究信息管理规范》参与起草单位。依托与多家三甲医院的项目合作实践，公司推出面向细胞制备、存储与临床研究应用的EH‑CLCMS细胞全生命周期信息化整体解决方案。
                    </div>
                    <div data-aos="fade-up">
                        作为信息化综合管理解决方案的重要组成部分，Ecell细胞全生命周期信息管理系统
是基于细胞全生命周期的干细胞资源库大数据管理平台，包括实验室资源子系统、项目管理子系统、样本流转子系统、细胞制备子系统、细胞质检子系统，用于管理细胞采集、检测、制备、质控、运输、存储、放行、销毁等各个阶段的数据，360度全周期贯穿从细胞采集到应用等的全流程，保障细胞制剂质量和细胞治疗应用的规范化，满足客户对细胞实验研究与临床应用的管理需求。
                    </div>
                </div>
                <div data-aos="zoom-in" style="padding:0 20px">
                    <img :src="require('@/assets/img/products/eCell/eCellTitle.png')" alt="" >
                </div>
            </div>
            <div class="framework">
                <div class="frameworkTitle" data-aos="zoom-in-up">系统框架</div>
                <div class="content">
                    <div class="contentTitle"  data-aos="fade-up">
                        WEB页面
                        <div>展示层</div>
                    </div>
                    <div class="contentTable">
                        <div>
                            <div>
                                <div v-for="item in frameworkList.application.list"  data-aos="fade-up">{{item}}</div>
                                <div  data-aos="fade-up">{{frameworkList.application.title}}</div>
                            </div>
                            <div>
                                <div>
                                    <div v-for="item in frameworkList.foundation.list"  data-aos="fade-up">{{item}}</div>
                                </div>
                                <div  data-aos="fade-up">
                                    {{frameworkList.foundation.title}}
                                </div>
                            </div>
                        </div>
                        <div>
                            <div v-for="item in frameworkList.application1.list"  data-aos="fade-up">{{item}}</div>
                            <div  data-aos="fade-up">{{frameworkList.application1.title}}</div>
                        </div>
                        <div>
                            <div v-for="item in frameworkList.data.list"  data-aos="fade-up">{{item}}</div>
                            <div  data-aos="fade-up">{{frameworkList.data.title}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="function">
                <div class="functionTitle" data-aos="zoom-in-up">功能特点</div>
                <div class="functionPic">
                    <img :src="require('@/assets/img/products/eCell/function1.png')" alt="" data-aos="zoom-in">
                    <img :src="require('@/assets/img/products/eCell/function2.png')" alt="" data-aos="zoom-in">
                </div>
                <div class="functionContent">
                    <div v-for="item in functionList">
                        <div class="title">{{item.title}}</div>
                        <div class="text">{{item.text}}</div>
                    </div>
                </div>
            </div>
            <div class="product">
                <div class="productTitle" data-aos="zoom-in-up">产品系列</div>
                <div class="productList" v-for="item in productList" data-aos="fade-up">
                    <div>{{item.title}}</div>
                    <div>{{item.text}}</div>
                </div>
                <div class="productPic">
                    <img :src="require('@/assets/img/products/eCell/proNew.jpg')" alt="" data-aos="zoom-in">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClcmsMenu from "../../components/ClcmsMenu";
export default {
    name:'Ecell',
    components: {ClcmsMenu},
    data(){
      return {
            frameworkList: {
                application:{
                    title:'应用层',
                    list:['试剂耗材管理','用户管理','系统管理','立项管理','实验方案','质检方案','制备实验','质检实验','质检报告','样本流转管理','空间位置管理','······']
                },
                foundation:{
                    title:'基础层',
                    list:['身份认证','权限管理','数据备份','报警设置']
                },
                application1:{
                    title:'应用层',
                    list:['实验室资源管理系统','干细胞临床研究信息管理系统','细胞制备过程数据管理系统','细胞质量验收管理系统','成体细胞综合存储库信息系统样本流转子系统']
                },
                data: {
                    title: '数据层',
                    list: ['关系型数据库', '文档数据库']
                }
            },
            functionList:[
                {
                    title:'·实现研究方案、人员、干细胞制备质检过程管理、数据管理的有效监控',
                    text:'打通干细胞生命周期内各研究分中心临床部、实验室、样本库、质控部、信息中心业务链路，构建完整业务工作闭环。'
                },
                {
                    title:'·实现干细胞临床研究项目的规范化管理',
                    text:'助力提升质控服务水平，保障业务运行质量稳定可控。'
                },
                {
                    title:'·实现干细胞制备实验室资源信息化管理',
                    text:'确保细胞生命周期所有信息可追溯、可审计。依托信息化手段搭建多中心干细胞临床研究协同管理信息平台，支撑干细胞临床研究跨地域多中心协同管理。'
                }
            ],
            productList:[
                {
                    title:'标准版',
                    text:'具备基本的项目管理功能，可以对项目下的细胞存储和出入库进行管理，对放行样本进行质检审核'
                },
                {
                    title:'商业版',
                    text:'注重客户信息和产品项目的合同管理，更加关注放行的质检报告'
                },
                {
                    title:'专业版',
                    text:'针对实验室，关注细胞制备的过程以及过程中各阶段的质检和实验资源的质控'
                },
                {
                    title:'企业版',
                    text:'具备专业版的所有功能，增加客户订单等管理，增加对细胞运输期间的监控及质量的控制和验证'
                },
                {
                    title:'旗舰版',
                    text:'在企业版基础上支持个性化定制开发，具备数据智能分析能力，可分析用户日常操作，为业务决策提供参考依据'
                },
            ]
      }
    },
    methods:{
        productsSelect(src){
	        this.$emit('productsSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .introduction{
        width: 1033px;
        margin: 0px 110px 0;
        display: flex;
        justify-content: space-between;
        padding-top: 213px;
        .introductionTitle{
            width: 526px;
            /*padding-top: 47px;*/
            h1{
                font-size: 19px;
            }
            &>div:nth-child(2){
                width: 65px;
                height: 2px;
                background: #006efd;
                margin: 13px 0 50px 0px;
            }
            &>div:nth-child(3),&>div:nth-child(4){
                font-size: 14px;
                letter-spacing: 1px;
                line-height: 30px;
                color: rgb( 51, 51, 51 );
                text-indent: 2em;
            }
        }
    }
    .framework{
        width: 1033px;
        margin: 90px 110px 0;
        .frameworkTitle{
            width: 126px;
            height: 29px;
            color: #fff;
            background: #006efd;
            text-align: center;
            line-height: 27px;
            font-weight: bold;
            letter-spacing: 4px;
            margin-bottom: 39px;
        }
        .content{
            width: 952px;
            .contentTitle{
                width: 100%;
                height: 51px;
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 51px;
                letter-spacing: 2px;
                color: #000000;
                text-align: center;
                position: relative;
                background-color: #6cabfe;
               div{
                    width: 50px;
                    height: 51px;
                    font-family: SourceHanSansCN-Normal;
                    font-size: 15px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 51px;
                    letter-spacing: 1px;
                    color: #000000;
                    position: absolute;
                    right: 92px;
                    top: 0px;
                }
            }
            .contentTable{
                width: 100%;
                margin-top: 15px;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                &>div:nth-child(1){
                    width: 474px;
                    height: 343px;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: end;
                    &>div:nth-child(1){
                        width: 100%;
                        height: 230px;
                        background: #f0f8fb;
                        display: flex;
                        justify-content: space-between;
                        flex-wrap: wrap;
                        padding: 12px 12px 0;
                        box-sizing: border-box;
                        div{
                            width: 147px;
                            height: 41px;
                            background-color: #c8d6e8;
                            font-size: 15px;
                            font-weight: normal;
                            font-stretch: normal;
                            line-height: 41px;
                            letter-spacing: 1px;
                            color: #000000;
                            text-align: center;
                        }
                        div:last-child{
                            width: 100%;
                            height: 49px;
                            text-align: center;
                            line-height: 49px;
                            background: none;
                        }
                    }
                    &>div:nth-child(2){
                        width: 100%;
                        height: 108px;
                        background: #eaeaea;
                        display: flex;
                        padding: 12px 12px 0;
                        box-sizing: border-box;
                        &>div:nth-child(1){
                            display: flex;
                            justify-content: space-between;
                            flex-wrap: wrap;
                            width: 297px;
                            div{
                                width: 147px;
                                height: 41px;
                                background-color: #c8d6e8;
                                font-size: 15px;
                                font-weight: normal;
                                font-stretch: normal;
                                line-height: 41px;
                                letter-spacing: 1px;
                                color: #000000;
                                text-align: center;
                            }
                        }
                        &>div:nth-child(2){
                            width: 156px;
                            height: 100%;
                            font-size: 15px;
                            font-weight: normal;
                            font-stretch: normal;
                            letter-spacing: 1px;
                            color: #000000;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }
                &>div:nth-child(2){
                    width: 474px;
                    height: 343px;
                    background: #f0f8fb;
                    padding: 12px;
                    box-sizing: border-box;
                    div{
                        width: 100%;
                        background: #c8d6e8;
                        height: 41px;
                        line-height: 41px;
                        text-align: center;
                        font-size: 15px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        color: #000000;
                        margin-bottom: 2px;
                    }
                    div:last-child{
                        height: 105px;
                        line-height: 105px;
                        background: none;
                    }
                }
                &>div:nth-child(3){
                    width: 100%;
                    height: 51px;
                    background: #eaeaea;
                    margin-top: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    div{
                        width: 147px;
                        height: 41px;
                        background-color: #a9cefe;
                        line-height: 41px;
                        text-align: center;
                        font-size: 15px;
                        letter-spacing: 1px;
	                    color: #000000;
                    }
                    div:nth-child(1){
                        margin-right: 30px;
                    }
                    div:nth-child(2){
                        margin-left: 30px;
                    }
                    div:last-child{
                        position: absolute;
                        height: 51px;
                        right: 20px;
                        background: none;
                        line-height: 51px;
                    }
                }
            }
        }
    }
    .function{
        width: 1033px;
        margin: 90px 110px 0;
        .functionTitle{
            width: 126px;
            height: 29px;
            color: #fff;
            background: #006efd;
            text-align: center;
            line-height: 27px;
            font-weight: bold;
            letter-spacing: 4px;
            margin-bottom: 39px;
        }
        .functionPic{
            width: 100%;
            padding: 0 54px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
        }
        .functionContent{
            margin-top: 65px;
            &>div{
                width: 961px;
                margin: 0 auto 24px;
                .title{
                    font-size: 15px;
                    font-weight: bold;
                    letter-spacing: 1px;
	                color: #000000;
                    line-height: 25px;
                }
                .text{
                    font-size: 15px;
                    font-weight: normal;
                    letter-spacing: 1px;
                    color: #2b2e2e;
                    line-height: 25px;
                }
            }
        }
    }
    .product{
        width: 1033px;
        margin: 90px 110px 0;
        .productTitle{
            width: 126px;
            height: 29px;
            color: #fff;
            background: #006efd;
            text-align: center;
            line-height: 27px;
            font-weight: bold;
            letter-spacing: 4px;
            margin-bottom: 35px;
        }
        .productList{
            width: 100%;
            padding-left: 90px;
            box-sizing: border-box;
            display: flex;
            margin-bottom: 6px;
            &>div:nth-child(1){
                width: 124px;
                height: 46px;
                background-color: #cce2ff;
                line-height: 46px;
                text-align: center;
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                color: #006efd;
                letter-spacing: 1px;
            }
            &>div:nth-child(2){
                height: 46px;
                line-height: 46px;
                font-size: 15px;
                font-weight: normal;
                font-stretch: normal;
                color: #2b2e2e;
                margin-left: 20px;
            }
        }
        .productPic{
            width: 100%;
            text-align: center;
            margin: 114px 0 135px;
            display: flex;
            align-items: center;
          justify-content: center;
        }
    }
</style>
